<template>
	<div>
		<div class="row mb-3">
			<div class="col-12 col-md-6 col-lg-8">
				<h1><em class="fas fa-users"></em> Users</h1>
			</div>
			<div class="col-12 col-md-6 col-lg-4 text-right">
				<router-link to="/user/0" class="btn btn-primary"><em class="fas fa-user-tie"></em> Add User</router-link>
			</div>
		</div>

		<div class="row mb-3" v-show="users.length > 0">
			<div class="col-12 col-lg-2">
				<label for="filter_acl_role_id" class="font-weight-bold">Role</label>
				<select class="form-control custom-select custom-select-sm" v-model="filters.acl_role_id" id="filter_acl_role_id" @change="saveFilters()">
					<option :value="null">All Roles</option>
					<option v-for="r in roles" :key="r.acl_role_id" :value="r.acl_role_id">{{r.role}}</option>
				</select>
			</div>
		</div>

		<div class="list-group">
			<router-link :to="'user/' + u.user_id" v-for="u in filteredUsers" :key="u.user_id" class="list-group-item list-group-item-action d-flex justify-content-between">
				<div>{{u.fname}} {{u.lname}}</div>
				<div>{{u.email}}</div>
			</router-link>
		</div>
	</div>
</template>

<script>
export default
{
	name: 'Users',
	props: ["current_user"],
	data: function()
	{
		return {
			users: [],
			roles: [],
			loading: true,
			filters: {acl_role_id: null}
		}
	},
	mounted: function()
	{
		this.restoreFilters();
		this.loadUsers();
		this.loadRoles();
	},
	computed:
	{
		filteredUsers: function()
		{
			var vm = this;

			return vm.users.filter(function(user)
			{
				var match = true;

				if(vm.filters.acl_role_id != null)
				{
					if(user.acl_role_ids == null)
					{
						user.acl_role_ids = "";
					}

					var ids = user.acl_role_ids.split(",");
					var found = false;

					for(var i=0; i<ids.length; i++)
					{
						if(ids[i] == vm.filters.acl_role_id)
						{
							found = true;
							break;
						}
					}

					match = match && (user.acl_role_id == vm.filters.acl_role_id || found);
				}

				return match;
			});
		}
	},
	methods:
	{
		loadUsers: function()
		{
			var vm = this;
			vm.loading = true;
			vm.startLoading();

			this.CORS("GET", "/users", null,
			function(response)
			{
				vm.users = response;
				vm.loading = false;
				vm.stopLoading();
			}, function(response)
			{
				vm.showError("Error Loading Users", response.responseText, true, null);
				vm.loading = false;
				vm.stopLoading();
			})
		},
		loadRoles: function()
		{
			var vm = this;
			vm.loading = true;
			vm.startLoading();

			this.CORS("GET", "/roles", null,
			function(response)
			{
				vm.roles = response;
				vm.loading = false;
				vm.stopLoading();
			}, function(response)
			{
				vm.showError("Error Loading Roles", response.responseText, true, null);
				vm.loading = false;
				vm.stopLoading();
			})
		},
		saveFilters: function()
		{
			if(this.filters["acl_role_id"] == null || this.filters["acl_role_id"] == "null")
			{
				localStorage.removeItem("acl_role_id");
			}
			else
			{
				localStorage.setItem("acl_role_id", String(this.filters["acl_role_id"]));
			}
		},
		restoreFilters: function()
		{
			if(localStorage.getItem("acl_role_id") != null)
			{
				this.filters["acl_role_id"] = String(localStorage.getItem("acl_role_id"));
			}
		}
	},
	watch: {
		'current_user' ()
		{
			if(this.current_user.user_id == null)
			{
				return;
			}

			if (!this.userHasAction(this.current_user, ['ADMIN']))
			{
				this.$router.push("/").catch(function() { /* ignore error */ });
			}
		}
	}
}
</script>
